import React from 'react';
import '../../assets/css/loadingFalllback.scss';

const LoadingFallback = () => {
  return <div className="loading-fallback">{/* Please Wait... */}</div>;
};

export default LoadingFallback;
